import React, { useState, useRef } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import {
  TooltipWrapper,
  TooltipContent,
  TooltipIcon,
  RoleDescription,
} from './component.styles'

const RoleHeader = ({ roles }) => {
  const [showTooltip, setShowTooltip] = useState(false)
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 })
  const iconRef = useRef(null)

  const handleMouseEnter = () => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect()
      setTooltipPosition({
        top: rect.bottom + 8,
        left: rect.left,
      })
    }
    setShowTooltip(true)
  }

  if (!roles || roles.length === 0) {
    return <>Role</>
  }

  return (
    <>
      Role{' '}
      <TooltipWrapper
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => setShowTooltip(false)}
        ref={iconRef}
      >
        <TooltipIcon />
        {showTooltip &&
          ReactDOM.createPortal(
            <TooltipContent
              style={{ top: tooltipPosition.top, left: tooltipPosition.left }}
            >
              {roles.map(role => (
                <RoleDescription key={role.name}>
                  <strong>{role.name}</strong>
                  {role.description}
                </RoleDescription>
              ))}
            </TooltipContent>,
            document.body,
          )}
      </TooltipWrapper>
    </>
  )
}

RoleHeader.propTypes = {
  roles: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
}

export default RoleHeader
